import React, { useState, useEffect } from "react";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  // @ts-ignore
} from "../../../components/ui/select";
// @ts-ignore
import { useDropdownData } from "../../Services/Common";
import { useInvitationManagement } from "../../Services/InvitationManagement";
import { useUserContext } from "../../../Contexts/UserProvider";
import { toast } from "react-toastify";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetFooter } from "../../../components/ui/sheet"
import {
  Building2,
  Loader2
} from "lucide-react"
import { inputFieldValidator } from "../../../Utilities/validation";

const InvitePartner = (props) => {
  const [inviteUserDetails, setInviteUserDetails] = useState({
    orgnizationName: undefined,
    orginzationType: undefined,
    email: undefined,
  });
  const [loading, setLoading] = useState(false);
  const { tenantUserType } = useDropdownData();
  const { sendInvitation } = useInvitationManagement();
  const { user, tenant } = useUserContext();
  const [errors, setErrors] = useState({
    orgnizationName: false,
    orginzationType: false,
    email: false,
  });

  const onChange = (event, type?) => {
    const detailType = type ? type : event?.target?.name;
    const detailValue = type ? event : event?.target?.value;

    setInviteUserDetails((prev) => ({
      ...prev,
      [detailType]: detailValue,
    }));

    // Clear error when user starts typing
    setErrors((prev) => ({ ...prev, [detailType]: detailValue.trim() === '' }));
  };

  const handleSubmit = () => {
    setLoading(true);
    const newErrors = {
      orgnizationName: inputFieldValidator(inviteUserDetails?.orgnizationName, "string"),
      orginzationType: inputFieldValidator(inviteUserDetails?.orginzationType, "string"),
      email: inputFieldValidator(inviteUserDetails?.email, "email")
    };

    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((v) => v);
    if (hasError) return setLoading(false);

    const obj = {
      userEmail: inviteUserDetails?.email,
      invitedTo: inviteUserDetails?.orgnizationName,
      invitedFromTenantId: tenant?.id,
      invitedFromTenantName: tenant?.name,
      invitedFromGlobalUserId: user?.userId,
      invitationSendOn: new Date(),
      invitationReSendOn: null,
      userTypeId: inviteUserDetails?.orginzationType,
    };

    sendInvitation(obj)
      .then((res) => {
        handleClose();
        toast.success("Partner Invitation Sent");
        props?.successCallBack();
        setLoading(false)
      })
      .catch((err) => {
        props.setIsShow(false);
        console.log(err);
        setLoading(false);
        toast.error(err?.response?.data?.Message);
      });
  };

  const handleClose = () => {
    setInviteUserDetails({
      orgnizationName: undefined,
      orginzationType: undefined,
      email: undefined,
    });
    props.setIsShow(false);
  }

  return (
    <div>
      <Sheet open={props?.isShow} onOpenChange={props.setIsShow}>
        <SheetContent side="right" className="w-full min-w-[600px] p-0 overflow-auto">
          <SheetHeader className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 border-b detail-header">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-purple-100 p-2 rounded-lg">
                  <Building2 className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <SheetTitle className="text-xl font-bold text-gray-900">Invite Companies</SheetTitle>
                  <p className="text-sm text-gray-600 mt-1">Invite companies to join us with as a Partners or Resellers</p>
                </div>
              </div>
            </div>
            <Button variant="outline" onClick={handleClose} className="close-panel">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x h-4 w-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
            </Button>
          </SheetHeader>
          <div className="p-6 space-y-6">
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs font-bold">Orgnization Name <span className="text-red-500">*</span></label>
                  <Input
                    type="text"
                    value={inviteUserDetails?.orgnizationName || undefined}
                    placeholder="Orgnization Name"
                    className={errors.orgnizationName ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                    name="orgnizationName"
                    onChange={(event) => onChange(event)}
                  />
                </div>
                <div>
                  <label className="text-xs font-bold">Orgination Type <span className="text-red-500">*</span></label>
                  <Select
                    value={inviteUserDetails?.orginzationType || undefined}
                    onValueChange={(event) => onChange(event, "orginzationType")}
                  >
                    <SelectTrigger
                      className={errors.orginzationType ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                    >
                      <SelectValue placeholder="Select Orgination Type" />
                    </SelectTrigger>
                    <SelectContent>
                      {tenantUserType?.map((item, index) => {
                        return (
                          <SelectItem key={index} value={item?.id}>
                            {item?.name}
                          </SelectItem>
                        );
                      })}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div>
                <label className="text-xs font-bold">Email <span className="text-red-500">*</span></label>
                <Input
                  type="email"
                  placeholder="Email"
                  className={errors.email ? "border-red-500 focus-visible:ring-red-500 w-full" : "w-full"}
                  name="email"
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>

            <SheetFooter>
              {/* Footer Actions */}
              <div className="absolute bottom-0 left-0 right-0 px-6 py-4 border-t border-border bg-card flex justify-end gap-3">
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={loading}
                  className="bg-primary text-primary-foreground hover:bg-primary/90"
                >
                  {loading ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Inviting...
                    </>
                  ) : (
                    "Invite Company"
                  )}
                </Button>
              </div>
            </SheetFooter>
          </div>
        </SheetContent>
      </Sheet>

    </div>
  );
};

export default InvitePartner;
